export default "__VITE_ASSET__124aa462__"